(() => {
  const params = new URLSearchParams(location.search);
  const incoming = (params.get('ref') || '').trim().slice(0, 80);
  const key = 'philistia-referral';
  const routeRoot = window.Shopify?.routes?.root || '/';
  const route = (path = '') => `${routeRoot.replace(/\/?$/, '/')}${String(path).replace(/^\/+/, '')}`;

  if (incoming && /^[A-Za-z0-9_-]+$/.test(incoming)) {
    try { localStorage.setItem(key, JSON.stringify({ code: incoming, savedAt: Date.now() })); } catch (_error) { /* storage is optional */ }
  }

  let referral = incoming;
  if (!referral) {
    try {
      const saved = JSON.parse(localStorage.getItem(key) || '{}');
      const thirtyDays = 30 * 24 * 60 * 60 * 1000;
      if (saved.code && Date.now() - Number(saved.savedAt || 0) < thirtyDays) referral = saved.code;
      else localStorage.removeItem(key);
    } catch (_error) { /* storage is optional */ }
  }
  if (!referral || !/^[A-Za-z0-9_-]+$/.test(referral)) return;

  fetch(route('cart/update.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: { 'Philistia referral code': referral } })
  }).catch(() => { /* checkout remains available if attribution cannot be saved */ });
})();
